import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import { withAccount } from '../../../../components/AccountContext';
import { searchJobProfile } from '../../../../services/apps/JobProfileService';
import { growlErrors } from '../../../../utils/NotificationUtil';

import TargetJobEditForm from './TargetJobEditForm';
import { withGrowl } from '../../../../components/GrowlNotifications';
import { growlShape } from '../../../../components/prop-types';

class JobProfileSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listJobProfiles: [],
      isJpLoading: false,
    };
    this.searchJobProfile = this.searchJobProfile.bind(this);
    this.updateTargetJob = this.updateTargetJob.bind(this);
  }

  async componentDidMount() {
    const { currentAccount, growl } = this.props;
    try {
      this.setState({
        isJpLoading: true,
      });
      const data = await searchJobProfile({ aid: currentAccount });
      this.setState({
        listJobProfiles: data,
        isJpLoading: false,
      });
    } catch (err) {
      growlErrors(growl, err);
      this.setState({
        isJpLoading: false,
      });
    }
  }

  updateTargetJob(value) {
    const { updateTargetJob } = this.props;
    updateTargetJob(value);
  }

  async searchJobProfile(query) {
    const { currentAccount, growl } = this.props;
    try {
      this.setState({
        isJpLoading: true,
      });
      const data = await searchJobProfile({ aid: currentAccount, query });
      this.setState({
        listJobProfiles: data,
        isJpLoading: false,
      });
    } catch (err) {
      growlErrors(growl, err);
      this.setState({
        isJpLoading: false,
      });
    }
  }

  render() {
    const { listJobProfiles, isJpLoading } = this.state;
    const { toggleEdit, respondent } = this.props;
    const initialValues = {
      respondentId: respondent.id,
      targetJob: respondent.targetJob,
    };

    return (
      <Formik
        initialValues={initialValues}
        onSubmit={(values, formikBag) => {
          const { resetForm } = formikBag;
          this.updateTargetJob(values);
          resetForm();
        }}
      >
        {() => (
          <TargetJobEditForm
            toggleEdit={toggleEdit}
            searchJobProfile={this.searchJobProfile}
            listJobProfiles={listJobProfiles}
            isJpLoading={isJpLoading}
          />
        )}
      </Formik>
    );
  }
}

JobProfileSearch.propTypes = {
  currentAccount: PropTypes.string.isRequired,
  growl: growlShape.isRequired,
  updateTargetJob: PropTypes.func.isRequired,
  toggleEdit: PropTypes.func.isRequired,
  respondent: PropTypes.objectOf(PropTypes.any).isRequired,
};

const mapStateToProp = (state, ownProps) => {
  let respondentId = null;

  if (ownProps.respondent) {
    respondentId = ownProps.respondent.id;
  }
  return {
    initialValues: {
      respondentId,
    },
  };
};

export default connect(mapStateToProp)(withGrowl(injectIntl(withAccount(JobProfileSearch))));
